import { MDRenderer } from "./MDRenderer";

type MarkdownPreviewProps = {
  content: string;
};

export function MarkdownPreview({ content }: MarkdownPreviewProps) {
  return (
    <div className="markdown-preview min-h-[200px] rounded-md border border-slate-200 bg-white p-4 text-sm leading-7 text-slate-700">
      <MDRenderer content={content || "*Nothing to preview yet.*"} />
    </div>
  );
}
